import React from 'react'

const EmailMessageContent = () => {
  return (
    <div>
      
    </div>
  )
}

export default EmailMessageContent
